module.exports = __webpack_public_path__ + "static/40-51797952a0c9f68455e6431852dd8d07.png";